import {
    Component,
    Inject,
    OnInit,
    PLATFORM_ID,
    TemplateRef,
    ViewChild,
    ElementRef,
    OnDestroy,
    AfterViewInit,
} from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { Observable, Subscription, forkJoin } from "rxjs";
import { Product } from "../../shared/classes/product";
import { ProductService } from "../../shared/services/product.service";
import { OrderService } from "../../shared/services/order.service";
import { WompiService } from "../../services/wompi.service";
import { Router } from "@angular/router";
import { User } from "../../shared/classes/user";
import { AuthService } from "../../shared/services/auth.service";
import { ToastrService } from "ngx-toastr";
import { HttpService } from "../../services/http.service";
import { ModalDismissReasons, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { isPlatformBrowser } from "@angular/common";
import Swal from "sweetalert2";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { DataSharingService } from "../../services/data-sharing.service";
import { FirestoreService } from "../../services/firestore.service";
import { CommonService } from "../../services/common.service";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { MapsAPILoader } from "@agm/core";
import { take } from "rxjs/operators";


declare var Stripe;
declare var google: any;
interface CardsDocument {
    cards: SavedCard[];
    updated_at?: Date;
    user_uid?: string;
}


interface SavedCard {
    id: string;
    card_number: string;
    cvv: string;
    last_digits: string;
    brand: string;
    exp_month: string;
    exp_year: string;
    card_holder_name: string;
    created: any;
    status: boolean;
    is_selected: boolean;
    pan_token: string | false;  // ✅ Cambiado de string | boolean a string | false
}



interface Country {
    name: string;
    cca2: string;
    flag: string;
    idd: string[];
}

interface PaymentMethod {
    name: string;
    isWompi: boolean;
    isCash: boolean;
    isStripe: boolean;
    txtMessage?: string;
    mainStatusOrder?: string;
    mainBadgeColor?: string;
    finalBadgeColor?: string;
    finalStatusOrder?: string;
    txtSuccess?: string;
    isPowerTranz: boolean;
}

interface ShippingMethod {
    active: boolean;
    name: string;
    isDelivery?: boolean;
    isPickup?: boolean;
}

interface BusinessPlace {
    company_dba_name: string;
    tax: number;
    street_address: string;
    business_place_latitude: number;
    business_place_longitude: number;
    delivery?: boolean;
    shipping_cost_delivery?: number;
    shipping_cost?: number;
    amount_min_order?: number;
    id?: string;
}

interface CostCustomDelivery {
    uid: string;
    cost: number;
    status: boolean;
    cost_additional?: number;
}

interface AppSettings {
    active_method_wompi?: boolean;
    active_method_cash?: boolean;
    active_method_card?: boolean;
    delivery_disabled?: boolean;
    delivery_custom_active?: boolean;
    limit_delivery?: number;
    only_delivery?: boolean;
    noteCheckOut?: any;
    active_verification_phone?: boolean;
}

interface UserLocation {
    lat: number;
    lng: number;
    address?: string;
    retrieved?: boolean;
}

interface DeliveryPriceResponse {
    delivery: {
        price: number;
        distance: number;
    };
}


@Component({
    selector: "app-checkout",
    templateUrl: "./checkout.component.html",
    styleUrls: ["./checkout.component.scss"],
})
export class CheckoutComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild("pasarelaWompi") pasarelaWompi: TemplateRef<any>;

    // User and form data
    user = new User();
    checkoutForm: FormGroup;
    currentLocation: UserLocation | null = null;

    // Product and order data
    products: Product[] = [];
    amount: number = 0;

    orderId: number | string = localStorage.getItem("orderId") || '';


    // Payment and shipping options
    payment: string = "Wompi";
    shipping: string = "";
    shippingTypeDelivery: string = "";
    methodShipping: ShippingMethod[] = [];
    methodInvoicing: any[] = [];
    metodoPago: PaymentMethod[] = [];
    pago: string = "";
    invoicing: string = "";
    sucursal: string = "";

    // UI and state flags
    isWompi: boolean = false;
    isCash: boolean = false;
    isStripe: boolean = false;
    isPowerTranz: boolean = false;

    verify: boolean = false;
    isLogged: boolean = false;
    closeResult: string = "";
    viewMap: boolean = false;
    onlyDelivery: boolean = false;

    // Messages and status
    txtMessage: string = "";
    mainStatusOrder: string = "";
    mainBadgeColor: string = "";
    finalBadgeColor: string = "";
    finalStatusOrder: string = "";
    txtSuccess: string = "";

    // Wompi payment
    data_wompi: any;
    urlPayment: SafeResourceUrl;

    // Stripe payment
    private stripe: any;
    private cardElement: any;
    private keyStripe: string = "";

    // Phone verification
    phone: string = "";
    number_to_verify: string = "";
    send_verification_code: boolean = false;
    codeVerificationCheck: string = "";
    active_verification_phone: boolean = true;
    updateWithoutPhone: boolean = true;

    // Delivery and location
    delivery_method: boolean = false;
    delivery: number = 0;
    method_shipping: string = "";
    sucursales: BusinessPlace[] = [];
    listCostCustomDelivery: CostCustomDelivery[] = [];
    selectCostCustomDelivery: CostCustomDelivery = {} as CostCustomDelivery;
    latLng: any;
    map: any;
    marker: any;
    latitude: number = 0;
    longitude: number = 0;
    shownewCardForm = true;
    public comercioId: string = '';


    // Tax and fees
    include_tax: boolean = localStorage.getItem("include_service_fee") === "true" || false;
    include_service_fee: boolean = localStorage.getItem("include_service_fee") === "true" || false;
    view_tax: boolean = localStorage.getItem("view_tax") === "true" || false;
    unique_tax: boolean = localStorage.getItem("unique_tax") === "true" || false;
    isWallet: boolean = localStorage.getItem("isWallet") === "true" || false;
    service_fee_limit: number = Number(localStorage.getItem("service_fee_limit")) || 0;
    service_fee_percent: number = Number(localStorage.getItem("service_fee_percent")) || 0;
    tax: number = Number(localStorage.getItem("current_tax")) || 0;
    tax_business: number = 0;

    // Wallet credits
    total_wallet: number = 0;
    used_credits: boolean = false;
    total_credits_used: number = 0;

    // General info
    infoGeneral: AppSettings = {};
    noteCheckOut: any = {};

    // Countries
    countries: Country[] = [];
    countryPrefix: { [code: string]: string } = {};
    countryMask: { [code: string]: string } = {};
    code: string = "";
    selectedCountry: string = "503";
    email: string = "";

    // Constants
    private readonly TWILIO_SERVICE_ENDPOINT = environment.twilio.TWILIO_SERVICE_ENDPOINT;
    private readonly TWILIO_SERVICE_VERIFICATION_CHECK = environment.twilio.TWILIO_SERVICE_VERIFICATION_CHECK;
    private readonly TWILIO_AUTH_TOKEN = environment.twilio.TWILIO_AUTH_TOKEN;
    private readonly TWILIO_ACCOUNT_SID = environment.twilio.TWILIO_ACCOUNT_SID;
    private readonly MIN_PHONE_LENGTH = 8;

    // Subscriptions
    private subscriptions: Subscription = new Subscription();
    private var_delivery_active: boolean = false;
    active_method_wompi: any;
    active_method_card: any;
    active_method_cash: any;
    // ADD POWERTRANZ PROPERTIES:
    selectedCard: any = null;
    TransactionIdentifier: string = "";
    orderIdentifier;
    totalAmount: number = 0;
    // Agregar estas variables al componente:
    savedCards: any[] = [];
    showAddCardForm: boolean = false;
    addCardForm: FormGroup;
    isAddingCard: boolean = false;
    private paymentWindow: Window | null = null;
    private paymentCheckInterval: any;
    private paymentTimeout: any;
    private isPaymentProcessing = false;

    private lastTransactionData: any = null;

    private tokenizationWindow: Window | null = null;
    private tokenizationCheckInterval: any = null;
    private tokenizationTimeout: any = null;
    private isTokenizationProcessing = false;

    showNewCardForm: boolean = false;
    newCardForm: FormGroup;
    isProcessingPayment: boolean = false;
    saveCard: boolean = false;
    private deliveryCalculationInProgress = false;
    amount_min_order: number = 0;
    delivery_distance_pricing: any = null;






    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
        private fb: FormBuilder,
        public productService: ProductService,
        public wompi: WompiService,
        private orderService: OrderService,
        private auth: AuthService,
        private toastrService: ToastrService,
        private service: HttpService,
        private modalService: NgbModal,
        private router: Router,
        private domSatizer: DomSanitizer,
        private dataSharingService: DataSharingService,
        private firestoreService: FirestoreService,
        private commonService: CommonService,
        private http: HttpClient,
        private elementRef: ElementRef,
        private mapsAPILoader: MapsAPILoader
    ) { }

    ngOnInit(): void {
        this.initForm();
        this.initDataSubscriptions();

        // ✅ Inicializar orderId si no existe
        if (!this.orderId) {
            const storedOrderId = localStorage.getItem("orderId");
            if (storedOrderId) {
                this.orderId = storedOrderId;
                //console.log('📋 OrderId cargado de localStorage:', this.orderId);
            }
        }

        this.getUser().then(() => {
            this.loadSavedCards();
            this.initAddCardForm()
        });

        this.getLocationToDisplay();
        this.socket();
        this.initializeStripeElements();
        this.verificationPhone();
    }


    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.initMap();
    }

    private initMap(): void {
        if (this.currentLocation) {
            this.loadMapGoogle(
                this.currentLocation.lat,
                this.currentLocation.lng,
                'currentLocationMap'
            );
        }
    }

    private initForm(): void {
        this.checkoutForm = this.fb.group({
            firstname: [
                "",
                [
                    Validators.required,
                    Validators.pattern("[a-zA-Z][a-zA-Z ]+[a-zA-Z]$"),
                ],
            ],
            lastname: [
                "",
                [
                    Validators.required,
                    Validators.pattern("[a-zA-Z][a-zA-Z ]+[a-zA-Z]$"),
                ],
            ],
            phone: ["", [Validators.required, Validators.pattern("[0-9]+")]],
            email: ["", [Validators.required, Validators.email]],
        });

        this.getCountries();
    }

    private initDataSubscriptions(): void {
        this.productService.updateCart();

        this.subscriptions.add(
            this.productService.cartItems.subscribe((response) => {
                this.products = response;
            })
        );

        this.subscriptions.add(
            this.getTotal.subscribe((amount) => {
                this.amount = Number(this.getNewTotal().toFixed(2));
            })
        );

        this.loadAppSettings();
    }

    private loadAppSettings(): void {
        this.subscriptions.add(
            this.service.sendGET_SettingsApp("General").subscribe((res) => {
                this.infoGeneral = res;
                this.metodoPago = res.method_payment || [];
                this.active_method_wompi = res.active_method_wompi || false;
                this.active_method_cash = res.active_method_cash || false;
                this.active_method_card = res.active_method_card || false;
                this.var_delivery_active = res.delivery_disabled || false;
                this.noteCheckOut = res.noteCheckOut || {};
                this.onlyDelivery = res.only_delivery !== undefined ? res.only_delivery : this.onlyDelivery;

                // ✅ Obtener configuración de precios por distancia
                this.delivery_distance_pricing = res.delivery_distance_pricing || null;

                if (res.delivery_disabled && res.delivery_custom_active) {
                    this.loadCustomDeliveryCosts();
                }

                this.loadShippingSettings();
            })
        );
    }


    private loadCustomDeliveryCosts(): void {
        this.subscriptions.add(
            this.firestoreService.getWhere("CostCustomDelivery", "status", true).subscribe((res) => {
                this.listCostCustomDelivery = res || [];
            })
        );
    }

    private loadShippingSettings(): void {
        this.subscriptions.add(
            this.service.sendGET_SettingsApp("Shipping").subscribe((res) => {
                this.methodShipping = res.method || [];

                if (this.infoGeneral.delivery_disabled) {
                    this.methodShipping.push({
                        active: true,
                        isDelivery: true,
                        name: "Delivery",
                    });

                    if (!this.onlyDelivery) {
                        this.methodShipping.push({
                            active: true,
                            name: "Pickup",
                            isPickup: true,
                        });
                    }
                }

                this.loadInvoicingSettings();
            })
        );
    }

    private loadInvoicingSettings(): void {
        this.subscriptions.add(
            this.service.sendGET_SettingsApp("Invoicing").subscribe((res) => {
                this.methodInvoicing = res.method || [];
            })
        );

        this.loadBusinessPlaces();
    }



    private loadBusinessPlaces(): void {
        this.subscriptions.add(
            this.service.sendGET_BusinessPlace().subscribe(async (res) => {
                //console.log(res);
                if (res?.length > 0) {
                    this.sucursales = res;
                    const sucursalProx = await this.encontrarCoordenadaMasCercana(res);
                    this.sucursal = sucursalProx.company_dba_name;
                    this.sucursal.includes;
                    this.comercioId = sucursalProx.id;

                    // ✅ Guardar el pedido mínimo
                    this.amount_min_order = sucursalProx.amount_min_order || 0;

                    this.sucursalRetiro(this.sucursal);
                }
            })
        );
    }


    private async getCurrentLocation(): Promise<UserLocation> {
        return new Promise((resolve, reject) => {
            if (!navigator.geolocation) {
                reject('Geolocation is not supported by your browser');
                return;
            }

            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    try {
                        const address = await this.reverseGeocode(
                            position.coords.latitude,
                            position.coords.longitude
                        );

                        resolve({
                            lat: position.coords.latitude,
                            lng: position.coords.longitude,
                            address: address || 'Ubicación actual',
                            retrieved: true
                        });
                    } catch (error) {
                        resolve({
                            lat: position.coords.latitude,
                            lng: position.coords.longitude,
                            retrieved: true
                        });
                    }
                },
                (error) => {
                    reject(`Error getting location: ${error.message}`);
                },
                { enableHighAccuracy: true, timeout: 10000 }
            );
        });
    }

    private async reverseGeocode(lat: number, lng: number): Promise<string> {
        return new Promise((resolve) => {
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode({ location: { lat, lng } }, (results, status) => {
                if (status === 'OK' && results?.[0]) {
                    resolve(results[0].formatted_address);
                } else {
                    resolve('');
                }
            });
        });
    }


    async getLocationToDisplay(): Promise<void> {
        try {
            this.currentLocation = await this.getCurrentLocation();
        } catch (error) {
            console.warn('No se pudo obtener ubicación actual:', error);
            // Usar la dirección guardada por defecto
            const defaultDirection = this.user.direction?.find(dir => dir.is_default);
            if (defaultDirection?.lat_long) {
                this.currentLocation = {
                    lat: defaultDirection.lat_long._lat,
                    lng: defaultDirection.lat_long._long,
                    address: defaultDirection.direction,
                    retrieved: false
                };
            }
        }

        if (this.currentLocation) {
            await this.loadMapGoogle(
                this.currentLocation.lat,
                this.currentLocation.lng,
                'currentLocationMap'
            );
        }
    }



    async encontrarCoordenadaMasCercana(coordenadas: BusinessPlace[]): Promise<BusinessPlace> {
        let puntoDeReferencia = { x: 0, y: 0 };

        try {
            const currentLocation = await this.getCurrentLocation();
            puntoDeReferencia = {
                x: currentLocation.lat,
                y: currentLocation.lng
            };
        } catch (error) {
            console.warn('No se pudo obtener ubicación actual, usando alternativa:', error);

            if (localStorage.getItem("data_direction")) {
                const dataLocation = JSON.parse(
                    localStorage.getItem("data_direction") || "{}"
                );
                puntoDeReferencia.x = dataLocation.lat_long?._lat || 0;
                puntoDeReferencia.y = dataLocation.lat_long?._long || 0;
            } else if (this.user.direction?.length > 0) {
                for (const element of this.user.direction) {
                    if (element.is_default) {
                        puntoDeReferencia.x = element.lat_long?._lat || 0;
                        puntoDeReferencia.y = element.lat_long?._long || 0;
                        break;
                    }
                }
            }
        }

        let distanciaMinima = Infinity;
        let coordenadaMasCercana = null;

        for (const coordenada of coordenadas) {
            const coordenadasBusiness = {
                x: coordenada.business_place_latitude,
                y: coordenada.business_place_longitude,
            };
            const distancia = this.calcularDistancia(
                puntoDeReferencia,
                coordenadasBusiness
            );
            if (distancia < distanciaMinima) {
                distanciaMinima = distancia;
                coordenadaMasCercana = coordenada;
            }
        }

        return coordenadaMasCercana || coordenadas[0];
    }

    calcularDistancia(punto1: { x: number; y: number }, punto2: { x: number; y: number }): number {
        return Math.sqrt(
            Math.pow(punto2.x - punto1.x, 2) + Math.pow(punto2.y - punto1.y, 2)
        );
    }


    loadMapGoogle(lat: number, lng: number, documentID: string): Promise<any> {
        if (!this.map) {
            return new Promise((resolve) => {
                this.latLng = new google.maps.LatLng(lat, lng);
                const mapOptions = {
                    center: this.latLng,
                    zoom: 16,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    disableDefaultUI: true,
                    draggable: true,
                    scrollwheel: true,
                };

                const componentMap = document.getElementById(documentID);
                if (componentMap) {
                    this.map = new google.maps.Map(componentMap, mapOptions);
                    this.map.addListener("tilesloaded", () => { });
                    this.markerOptions(false);
                    resolve({ lat, lng });
                }
            });
        }
        return Promise.resolve({ lat, lng });
    }

    markerOptions(draggable: boolean): void {
        this.marker = new google.maps.Marker({
            map: this.map,
            draggable: draggable,
            title: "Drag the marker",
            animation: google.maps.Animation.DROP,
            position: this.latLng,
            icon: {
                url: "https://firebasestorage.googleapis.com/v0/b/ianos-platform-dev.appspot.com/o/assets%2Fuploads%2Fpin.png?alt=media&token=59779625-31d7-4394-9649-08957bf56015",
            },
        });

        this.marker.addListener("dragend", () => {
            this.latitude = this.marker.getPosition().lat();
            this.longitude = this.marker.getPosition().lng();
            this.mapsAPILoader.load().then(() => { });
        });
    }

    initializeStripeElements(): void {
        if (typeof Stripe !== "undefined") {
            this.subscriptions.add(
                this.firestoreService
                    .getOne("Settings", "Payment")
                    .subscribe((res: any) => {
                        this.email = this.user.email;
                        const stripeKey = res["stripe_mode_live"]
                            ? res["stripe_pk_live"]
                            : res["stripe_pk_test"];
                        this.keyStripe = stripeKey;
                        this.stripe = Stripe(stripeKey);

                        const elements = this.stripe.elements();
                        this.cardElement = elements.create("card", {
                            style: {
                                base: {
                                    iconColor: "#000000",
                                    color: "#000000",
                                    fontWeight: "500",
                                    fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
                                    fontSize: "16px",
                                    fontSmoothing: "antialiased",
                                    ":-webkit-autofill": { color: "#000000" },
                                    "::placeholder": { color: "##777777" },
                                },
                                invalid: {
                                    iconColor: "##777777",
                                    color: "##777777",
                                },
                            },
                            hidePostalCode: true,
                        });

                        const cardElement =
                            this.elementRef.nativeElement.querySelector("#card-element");
                        if (cardElement) {
                            this.cardElement.mount(cardElement);
                        }
                    })
            );
        } else {
            console.error("Stripe.js no está cargado.");
        }
    }

    async onPay(): Promise<void> {
        try {
            if (!this.stripe) {
                console.error("Stripe no está inicializado.");
                return;
            }

            const { token, error } = await this.stripe.createToken(this.cardElement, {
                name: `${this.user.firstName} ${this.user.lastName}`,
            });

            if (error) {
                this.handlePaymentError(error);
            } else {
                console.info("Token de stripe", token);
            }
        } catch (error) {
            this.handlePaymentError(error);
        }
    }

    async onPay2(): Promise<void> {
        try {
            if (!this.stripe) {
                console.error("Stripe no está inicializado.");
                return;
            }

            this.showProcessingPaymentAlert();

            await this.verifyUid();

            const { token, error } = await this.stripe.createToken(this.cardElement, {
                name: `${this.user.firstName} ${this.user.lastName}`,
            });

            if (error) {
                this.handlePaymentError(error);
            } else {
                await this.processStripePayment(token);
            }
        } catch (error) {
            this.handlePaymentError(error);
        }
    }

    private async processStripePayment(token: any): Promise<void> {
        const products = this.products.map((p) => p.product_name).join(" || ");
        const payment_amount = Number(this.getNewTotal().toFixed(2));

        const dataCreateOrder = {
            product: this.products,
            details: this.checkoutForm.value,
            orderId: this.orderId,
            amount: this.getNewTotal(),
            subtotal: this.getSubtotal(),
            tax: this.getTax(),
            is_delivery: this.method_shipping === "Delivery",
            subtotalForRide: this.delivery,
            serviceFee: this.serviceFee(),
            used_credits: this.total_credits_used,
        };

        const createOrder = this.orderService.createOrder(dataCreateOrder);

        const dataPost = {
            email: this.user.email,
            name: `${this.user.firstName} ${this.user.lastName}`,
            uid: this.user.uid,
            id: token.id,
            card: this.removeNullProp(token.card),
            created: token.created,
            payment_amount: payment_amount * 100,
            currency: "usd",
            description: `Compra Tienda en linea - ${this.orderId}`,
            metadata: {
                user_uid: this.user.uid,
                email: this.user.email,
                items: products,
            },
            time: new Date().getTime(),
        };

        try {
            const res1: any = await this.service.createCustomerPost(dataPost);
            if (res1.success) {
                this.orderService.processOrder(this.user, 666);
                Swal.close();
                Swal.fire({
                    icon: "success",
                    title: "Listo",
                    text: "Pago realizado",
                });
            } else {
                this.handlePaymentError("Error processing payment");
            }
        } catch (err) {
            this.handlePaymentError(err);
        }
    }

    private handlePaymentError(error: any): void {
        console.error("Payment error:", error);
        Swal.close();
        Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error.message || error,
        });
    }

    private showProcessingPaymentAlert(): void {
        Swal.fire({
            icon: "info",
            title: "Procesando pago, espere un momento por favor",
            showConfirmButton: false,
            backdrop: "static",
            allowOutsideClick: false,
        });
    }

    removeNullProp(obj: any): any {
        return Object.fromEntries(
            Object.entries(obj).filter(
                ([_, value]) => value !== null && value !== undefined
            )
        );
    }

    public get getTotal(): Observable<number> {
        return this.productService.cartTotalAmount();
    }

    pagoWompi(content: TemplateRef<any>): void {
        this.verifyForm()
            .then(async () => {
                this.showProcessingPaymentAlert();
                await this.updateNameUser();
                await this.verifyUid();

                const products = this.products.map((p) => p.product_name).join(" || ");
                const dataCreateOrder = {
                    product: this.products,
                    details: this.checkoutForm.value,
                    orderId: this.orderId,
                    amount: this.getNewTotal(),
                    subtotal: this.getSubtotal(),
                    tax: this.getTax(),
                    is_delivery: this.method_shipping === "Delivery",
                    subtotalForRide: this.delivery,
                    serviceFee: this.serviceFee(),
                    used_credits: this.total_credits_used,
                };

                const createOrder = this.orderService.createOrder(dataCreateOrder);

                const data = {
                    token: "",
                    identificadorEnlaceComercio: `Pedido # ${this.orderId}`,
                    monto: createOrder.checkoutItems.totalAmount,
                    nombreProducto: products,
                    configuracion: {
                        esMontoEditable: false,
                        esCantidadEditable: false,
                        duracionInterfazIntentoMinutos: 30,
                        emailsNotificacion: createOrder.checkoutItems.shippingDetails.email,
                        notificarTransaccionCliente: true,
                    },
                };

                try {
                    const toke: any = await this.wompi.wompiApiAuthentication();
                    data.token = toke.access_token;

                    const res: any = await this.wompi.EnlacePago(data);
                    if (res.success) {
                        this.data_wompi = res;
                        this.data_wompi.access_token = toke.access_token;
                        this.verify = true;
                        this.urlPayment = this.domSatizer.bypassSecurityTrustResourceUrl(
                            res.urlPayment
                        );
                        this.orderService.processOrder(this.user, 666, this.data_wompi);
                        Swal.close();
                        this.openVerticallyCentered(content);
                    } else {
                        this.handlePaymentError("Error generating payment");
                    }
                } catch (err) {
                    this.handlePaymentError("Error processing payment");
                }
            })
            .catch((err) => {
                Swal.fire("Atención!", err, "info");
            });
    }

    updateNameUser(): Promise<void> {
        const message_post = {
            firstName: this.user.firstName,
            lastName: this.user.lastName,
            current_name: `${this.user.firstName} ${this.user.lastName}`,
        };
        return this.updateUser(message_post, this.user.uid)
            .then(() => console.info("user updated"))
            .catch((err) => console.error("error updating user", err));
    }

    confirmParymentWompi(): void {
        Swal.fire({
            icon: "info",
            title: "Confirmando pago, espere un momento por favor",
            showConfirmButton: false,
            backdrop: "static",
            allowOutsideClick: false,
        });

        const data = {
            id: this.data_wompi.idLink,
            token: this.data_wompi.access_token,
        };

        this.wompi.EnlacePagoId(data).then((confirm: any) => {
            if (confirm.estaProductivo) {
                if (confirm.esAprobada) {
                    this.handleSuccessfulPayment();
                } else {
                    Swal.fire(
                        "Error",
                        "No hemos podido verificar el pago real realizado en la pasarela de pago.",
                        "error"
                    );
                }
            } else {
                this.handleSuccessfulPayment();
            }
        });
    }

    private handleSuccessfulPayment(): void {
        Swal.fire("Exito", "Pago procesado correctamente", "success").then(() => {
            localStorage.removeItem("cartItems");
            localStorage.removeItem("orderId");
            window.location.href = `/shop/checkout/success/${localStorage.getItem(
                "order_uid"
            )}`;
        });
    }

    metodoEnvio(event: string): void {
        const select = this.methodShipping.find((item) => item.name === event);
        if (select) {
            this.delivery_method = select.isDelivery || false;
            this.method_shipping = select.isDelivery ? "Delivery" : "";
            this.viewMap = select.isDelivery;

            if (this.viewMap) this.getLocationToDisplay();
        }
    }


    tipoEnvio(event: string): void {
        const select = this.listCostCustomDelivery.find(
            (item) => item.uid === event
        );
        if (select) {
            localStorage.setItem("typeDelivery", JSON.stringify(select));
            this.selectCostCustomDelivery = select;
            this.method_shipping = "delivery";
            this.calculateMethodCustomDelivery();

            if (this.user.direction?.length > 0) {
                setTimeout(() => {
                    this.user.direction.forEach((element, index) => {
                        if (
                            element.is_default &&
                            element.lat_long?._lat &&
                            element.lat_long?._long
                        ) {
                            this.loadMapGoogle(
                                element.lat_long._lat,
                                element.lat_long._long,
                                'currentLocationMap'
                            );
                        }
                    });
                }, 500);
            }
        }
    }

    documentoGenerar(event: string): void {
        localStorage.setItem("invoicing", event);
        if (this.user.direction?.length > 0) {
            setTimeout(() => {
                this.user.direction.forEach((element, index) => {
                    if (
                        element.is_default &&
                        element.lat_long?._lat &&
                        element.lat_long?._long
                    ) {
                        this.loadMapGoogle(
                            element.lat_long._lat,
                            element.lat_long._long,
                            'currentLocationMap'
                        );
                    }
                });
            }, 500);
        }
    }


    sucursalRetiro(event: string): void {
        const select = this.sucursales.find(
            (item) => item.company_dba_name === event
        );

        if (select) {
            this.tax_business = select.tax;

            // ✅ Guardar el pedido mínimo de la sucursal seleccionada
            this.amount_min_order = select.amount_min_order || 0;

            localStorage.setItem("sucursal", event);
            localStorage.setItem("commerce_direction", select.street_address);
            localStorage.setItem(
                "commerce_ubication",
                JSON.stringify({
                    lat: select.business_place_latitude,
                    long: select.business_place_longitude,
                })
            );

            if (this.var_delivery_active) {
                if (
                    this.infoGeneral.delivery_disabled &&
                    this.infoGeneral.delivery_custom_active
                ) {
                    this.method_shipping = "delivery";
                    this.calculateMethodCustomDelivery();
                } else {
                    if (select.delivery) {
                        this.method_shipping = "delivery";

                        // ✅ Calcular delivery por distancia si está activo
                        this.calculateDeliveryPrice(select);
                    } else {
                        this.method_shipping = "pickup";
                        this.delivery = Number.parseFloat(
                            this.ToFixed(select.shipping_cost)
                        );
                    }
                }

                if (this.user.direction?.length > 0) {
                    setTimeout(() => {
                        this.user.direction.forEach((element, index) => {
                            if (
                                element.is_default &&
                                element.lat_long?._lat &&
                                element.lat_long?._long
                            ) {
                                this.loadMapGoogle(
                                    element.lat_long._lat,
                                    element.lat_long._long,
                                    'currentLocationMap'
                                );
                            }
                        });
                    }, 500);
                }
            } else {
                this.method_shipping = "Pickup";
            }
        } else {
            this.method_shipping = "";
            this.delivery = 0;
            this.tax_business = 0;
            this.amount_min_order = 0;
            localStorage.setItem("sucursal", "");
            localStorage.setItem("commerce_direction", "");
            localStorage.setItem("commerce_ubication", "");
        }
    }




    private async calculateDeliveryPrice(sucursal: BusinessPlace): Promise<void> {
        try {
            // Verificar si el pricing por distancia está activo
            if (this.delivery_distance_pricing?.isActive) {
                const userLocation = await this.getUserLocationForDelivery();

                if (userLocation) {
                    const distance = this.calcularDistancia(
                        { x: userLocation.lat, y: userLocation.lng },
                        { x: sucursal.business_place_latitude, y: sucursal.business_place_longitude }
                    );

                    // Convertir de grados a millas (aproximación)
                    const distanceInMiles = distance * 69; // 1 grado ≈ 69 millas

                    //console.log(`📍 Distancia calculada: ${distanceInMiles.toFixed(2)} millas`);

                    // Llamar al backend para obtener el precio
                    this.delivery = await this.calculateDeliveryByDistance(distanceInMiles);
                } else {
                    // Usar precio por defecto si no hay ubicación
                    this.delivery = Number.parseFloat(
                        this.ToFixed(sucursal.shipping_cost_delivery)
                    );
                }
            } else {
                // Usar el precio estático de la sucursal
                this.delivery = Number.parseFloat(
                    this.ToFixed(sucursal.shipping_cost_delivery)
                );
            }
        } catch (error) {
            console.error('Error calculando precio de delivery:', error);
            // Fallback al precio estático
            this.delivery = Number.parseFloat(
                this.ToFixed(sucursal.shipping_cost_delivery)
            );
        }
    }
    private async getUserLocationForDelivery(): Promise<{ lat: number; lng: number } | null> {
        try {
            if (this.currentLocation) {
                return {
                    lat: this.currentLocation.lat,
                    lng: this.currentLocation.lng
                };
            }

            if (this.user.direction?.length > 0) {
                const defaultDirection = this.user.direction.find(dir => dir.is_default);
                if (defaultDirection?.lat_long) {
                    return {
                        lat: defaultDirection.lat_long._lat,
                        lng: defaultDirection.lat_long._long
                    };
                }
            }

            return null;
        } catch (error) {
            console.error('Error obteniendo ubicación:', error);
            return null;
        }
    }




    private getDefaultDeliveryPrice(): number {
        const sucursal = this.sucursales.find(
            (item) => item.company_dba_name === this.sucursal
        );

        return sucursal?.shipping_cost_delivery
            ? Number.parseFloat(this.ToFixed(sucursal.shipping_cost_delivery))
            : 0;
    }
    verifyForm(): Promise<void> {
        if (this.active_verification_phone) {
            this.updateWithoutPhone = this.user.verificate_phone === true;
        }

        const errors = [];

        // ✅ VALIDACIÓN DE PEDIDO MÍNIMO
        if (this.amount_min_order > 0) {
            const subtotal = this.getSubtotal();
            if (subtotal < this.amount_min_order) {
                errors.push(`El pedido mínimo es $${this.amount_min_order.toFixed(2)}`);
            }
        }

        if (this.shipping === "") errors.push("Método de envío");
        if (this.invoicing === "") errors.push("Documento a generar");
        if (this.sucursal === "") errors.push("Sucursal de retiro");
        if (this.delivery_method && (!this.user.direction || this.user.direction.length === 0)) {
            errors.push("Dirección de Entrega");
        }
        if (!this.updateWithoutPhone) errors.push("Número de teléfono validado");
        if (this.user.firstName?.length < 3) errors.push("Nombre debe contener al menos 3 caracteres");
        if (this.user.lastName?.length < 3) errors.push("Apellido debe contener al menos 3 caracteres");
        if (this.pago === "") errors.push("Método de pago");

        // Validación PowerTranz
        if (this.isPowerTranz) {
            if (this.showNewCardForm) {
                if (!this.newCardForm.valid) {
                    errors.push("Datos de tarjeta completos y válidos");
                }
            } else if (!this.selectedCard) {
                errors.push("Tarjeta de crédito/débito");
            }
        }

        if (errors.length > 0) {
            return Promise.reject(`Los siguientes campos son requeridos: ${errors.join(", ")}`);
        }

        return Promise.resolve();
    }



    async calculateDeliveryByDistance(distanceInMiles: number): Promise<number> {
        // Evitar cálculos duplicados
        if (this.deliveryCalculationInProgress) {
            //console.log('Cálculo de delivery ya en progreso, ignorando...');
            return this.delivery;
        }

        try {
            this.deliveryCalculationInProgress = true;
            //console.log(`🔍 Consultando precio de entrega para distancia: ${distanceInMiles.toFixed(2)} millas`);

            const payload = {
                apiKey: environment.apikey,
                distance: distanceInMiles
            };

            const response = await this.service.sendPOST_DeliveryPrice(payload) as DeliveryPriceResponse;

            if (
                response &&
                response.delivery &&
                typeof response.delivery.price === 'number'
            ) {
                const price = response.delivery.price;
                //console.log(`✅ Precio recibido: ${price}`);
                return price;
            } else {
                console.error('Respuesta inválida del backend:', response);
                return this.getDefaultDeliveryPrice();
            }

        } catch (error) {
            console.error('❌ Error consultando backend:', error);
            return this.getDefaultDeliveryPrice();
        } finally {
            this.deliveryCalculationInProgress = false;
        }
    }

    async calculateMethodCustomDelivery(): Promise<void> {
        this.delivery = this.selectCostCustomDelivery.cost || 0;
        const costDeliveryByProduct: any[] = [];

        for (const element of this.products) {
            try {
                const productInfo = await this.getInfoProduct(element);
                if (productInfo?.custom_delivery) {
                    const select = productInfo.custom_delivery.find(
                        (item) =>
                            item.uid === this.selectCostCustomDelivery.uid && item.status
                    );

                    if (select) {
                        const filterProd = costDeliveryByProduct.find(
                            (item) =>
                                item.cost_additional === select.cost_additional &&
                                this.infoGeneral.limit_delivery > item.quantity
                        );

                        if (!filterProd) {
                            costDeliveryByProduct.push({
                                cost: select.cost,
                                cost_additional: select.cost_additional,
                                price: Number(element.price),
                                quantity: element.quantity,
                            });
                            this.delivery += select.cost_additional;
                        } else {
                            filterProd.quantity += element.quantity;
                        }
                    }
                }
            } catch (error) {
                console.error("Error calculating delivery cost:", error);
            }
        }
    }

    getInfoProduct(element: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.firestoreService
                .getOneWatcher("Products", element.id || element.uid)
                .pipe(take(1))
                .subscribe(
                    (res) => resolve(res),
                    (err) => reject(err)
                );
        });
    }



    private getUserDirection(): any {
        if (this.currentLocation && this.currentLocation.address) {
            return {
                address: this.currentLocation.address,
                lat: this.currentLocation.lat,
                lng: this.currentLocation.lng,
                is_default: false
            };
        }

        if (this.user.direction?.length > 0) {
            const defaultDirection = this.user.direction.find(dir => dir.is_default);
            if (defaultDirection) {
                return {
                    ...defaultDirection,
                    lat: defaultDirection.lat_long?._lat || defaultDirection.lat_long?._lat,
                    lng: defaultDirection.lat_long?._long || defaultDirection.lat_long?._long
                };
            }
        }

        return null;
    }

    async confirmarPedido(): Promise<void> {

        try {
            await this.verifyForm();
            // AGREGAR ESTA CONDICIÓN PARA POWERTRANZ
            if (this.isPowerTranz) {
                await this.processPowerTranzPayment();
                return; // Salir del método, el flujo continúa en PowerTranz
            }

            // Tu flujo normal existente para otros métodos de pago
            //  await this.verifyForm();
            await this.updateNameUser();
            await this.verifyUid();

            const templateContent = document.getElementById("table-invoice")?.innerHTML || "";
            localStorage.setItem("templateContent", templateContent);

            this.showProcessingPaymentAlert();
            const userDirection = this.getUserDirection();

            const dataCreateOrder = {
                product: this.products,
                details: this.checkoutForm.value,
                orderId: this.orderId,
                amount: this.getNewTotal(),
                tax: this.getTax(),
                is_delivery: this.method_shipping === "Delivery",
                method_shipping: this.method_shipping,
                subtotalForRide: this.delivery,
                subtotal: this.getSubtotal(),
                serviceFee: this.serviceFee(),
                used_credits: this.total_credits_used,
                direction: userDirection
            };

            this.orderService.createOrder(dataCreateOrder);
            this.orderService.processOrder(this.user, 666);
        } catch (err) {
            Swal.fire("Atención!", err as string, "info");
        }
    }



    openModal(): void {
        if (isPlatformBrowser(this.platformId)) {
            this.modalService
                .open(this.pasarelaWompi, {
                    size: "md",
                    backdrop: "static",
                    keyboard: false,
                    centered: true,
                    windowClass: "bd-example-modal-md theme-modal agem",
                })
                .result.then(
                    (result) => `Result ${result}`,
                    (reason) => {
                        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
                    }
                );
        }
    }

    openVerticallyCentered(content: TemplateRef<any>): void {
        this.modalService.open(content, {
            centered: true,
            size: "xl",
            backdrop: "static",
            keyboard: false,
            windowClass: "modal-2",
            animation: true,
        });
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return "by pressing ESC";
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return "by clicking on a backdrop";
        } else {
            return `with: ${reason}`;
        }
    }

    cancelPaymentWompi(): void {
        const order_uid = localStorage.getItem("order_uid");
        if (order_uid) {
            this.subscriptions.add(
                this.service.getOneOrder(order_uid).subscribe((order) => {
                    const message = {
                        ...order,
                        orders_status_uid: "Payment Failed",
                        badgeColor: "danger",
                    };

                    this.service.updateOrder(message, message.id).then(() => {
                        this.modalService.dismissAll("Se arrepintio");
                        this.getStock(message).then((stock) => {
                            setTimeout(() => {
                                this.updateStock(stock).then(() => {
                                    this.router.navigate(["/shop/cart"]);
                                });
                            }, 1000);
                        });
                    });
                })
            );
        }
    }

    getStock(order: any): Promise<any[]> {
        const update: any[] = [];

        return new Promise((resolve) => {
            const productObservables = order.items.map((element: any) =>
                this.service.getOneProduct(element.uid).pipe(take(1))
            );

            forkJoin(productObservables).subscribe((products: any) => {
                products.forEach((res: any, index: number) => {
                    const element = order.items[index];
                    const new_products_stock = res.products_stock + element.quantity;
                    const updatedProduct = {
                        ...res,
                        products_stock: new_products_stock,
                        product_availability:
                            new_products_stock > 0 ? "Stock" : "Out of stock",
                        product_background_availability:
                            new_products_stock > 0 ? "success" : "danger",
                    };
                    update.push(updatedProduct);
                });
                resolve(update);
            });
        });
    }

    async updateStock(stock: any[]): Promise<void> {
        try {
            for (const element of stock) {
                const clonedObject = { ...element };
                delete clonedObject.old_products_stock;

                const messagePost = {
                    products_stock: element.products_stock,
                };

                const dataLog = {
                    reason: `Update product - Checkout ${this.orderId}`,
                    user_uid: this.user.uid,
                    name_user: `${this.user.firstName} ${this.user.lastName}`,
                    date: Date.now(),
                    from: "Tienda Online",
                    product_uid: element.id,
                    data_send: element,
                    quantity_before: clonedObject.products_stock || 0,
                    quantity_after: element.products_stock || 0,
                    price_before: clonedObject.price_tax_product || 0,
                    price_after: clonedObject.price_tax_product || 0,
                    discount_before: clonedObject.discount || 0,
                    discount_after: clonedObject.discount || 0,
                };

                const log = {
                    info: dataLog,
                    product_uid: element.id,
                };

                await this.productService.saveLog(log);
                await this.service.sendPUT_Product(messagePost, element.id);
            }

            window.location.href = "/shop/cart";
        } catch (error) {
            console.error("Error updating stock:", error);
            throw error;
        }
    }

    socket(): void {
        this.subscriptions.add(
            this.dataSharingService.include_service_fee.subscribe(
                (valor: boolean) => {
                    this.include_service_fee = valor;
                }
            )
        );

        this.subscriptions.add(
            this.dataSharingService.include_tax.subscribe((valor: boolean) => {
                this.include_tax = valor;
            })
        );

        this.subscriptions.add(
            this.dataSharingService.service_fee_percent.subscribe((valor: number) => {
                this.service_fee_percent = valor;
            })
        );

        this.subscriptions.add(
            this.dataSharingService.service_fee_limit.subscribe((valor: number) => {
                this.service_fee_limit = valor;
            })
        );

        this.subscriptions.add(
            this.dataSharingService.currentTaxSubject.subscribe((valor: number) => {
                this.tax = valor;
            })
        );

        this.subscriptions.add(
            this.dataSharingService.view_tax.subscribe((valor: boolean) => {
                this.view_tax = valor;
            })
        );

        this.subscriptions.add(
            this.dataSharingService.unique_tax.subscribe((valor: boolean) => {
                this.unique_tax = valor;
            })
        );
    }

    getUser(): Promise<void> {
        return new Promise((resolve, reject) => {
            this.auth.getUser2().then(async (userLocal) => {
                this.isLogged = true;
                this.user = userLocal;

                if (userLocal.phone?.["nationalNumber"]) {
                    this.phone = userLocal.phone["nationalNumber"];
                    const userPhone: any = this.user.phone;
                    this.code = `+${userPhone?.dialCode?.replace(/\+|\s/g, "")}`;
                } else {
                    this.getDefaultCountry();
                }

                if (!this.user.emailVerified) {
                    this.getUserFirebase();
                }

                this.checkoutForm.patchValue({
                    firstname: this.user.firstName,
                    lastname: this.user.lastName,
                    phone: this.user.phone?.internationalNumber || this.user.phone,
                    email: this.user.email,
                });

                this.verifyWallet();
                resolve();
            }).catch((error) => {
                this.router
                    .navigate(["/pages/login"])
                    .then(() =>
                        this.toastrService.info(
                            "Estimado usuario, es necesario iniciar sesión para continuar con el proceso de compra."
                        )
                    );
                reject(error);
            });
        });
    }


    verifyWallet(): void {
        if (this.isWallet) {
            this.subscriptions.add(
                this.firestoreService
                    .getWhere("Wallet", "uid", this.user.uid)
                    .subscribe((res) => {
                        if (res?.length > 0) {
                            this.total_wallet = res[0].total;
                        }
                    })
            );
        }
    }

    async sendVerificationCode(phone: string): Promise<void> {
        const tel = phone.toString().replaceAll(" ", "");
        const number = `+${this.code}${tel}`;

        if (tel.length < this.MIN_PHONE_LENGTH) {
            throw new Error(
                "Invalid phone number. Please enter a valid phone number."
            );
        }

        const data = new URLSearchParams();
        data.append("To", number);
        data.append("Channel", "sms");

        try {
            const response = await fetch(this.TWILIO_SERVICE_ENDPOINT, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    Authorization: `Basic ${btoa(
                        `${this.TWILIO_ACCOUNT_SID}:${this.TWILIO_AUTH_TOKEN}`
                    )}`,
                },
                body: data.toString(),
            });

            if (!response.ok) {
                throw new Error(
                    "Failed to send verification code. Please try again later."
                );
            }

            Swal.fire(
                "Success",
                "El código ha sido enviado correctamente, por favor ingrese el código que ha sido enviado a su número, para poder validarlo en nuestro sistema.",
                "success"
            );
            this.send_verification_code = true;
            this.number_to_verify = number;
        } catch (error) {
            console.error(error);
            throw new Error(
                "Failed to send verification code. Please try again later."
            );
        }
    }

    checkVerificationCode(): void {
        const code = this.codeVerificationCheck.toString();
        const body = new URLSearchParams();
        body.set("To", this.number_to_verify);
        body.set("Code", code);

        fetch(this.TWILIO_SERVICE_VERIFICATION_CHECK, {
            method: "POST",
            headers: {
                Authorization: `Basic ${btoa(
                    `${this.TWILIO_ACCOUNT_SID}:${this.TWILIO_AUTH_TOKEN}`
                )}`,
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: body.toString(),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === "approved" && data.valid) {
                    const formattedNumber = this.commonService.formattedNumber(
                        this.phone
                    );
                    this.user.verificate_phone = true;

                    const message_post = {
                        verificate_phone: true,
                        date_verify: Date.now(),
                        user_uid_verify: this.user.uid,
                        name_user_verify: this.user.firstName,
                        verification_code: code,
                        phone: {
                            isoCode: "sv",
                            internationalNumber: `+${this.code} ${formattedNumber}`,
                            dialCode: `+${this.code}`,
                            nationalNumber: formattedNumber,
                        },
                    };

                    this.updateUser(message_post, this.user.uid)
                        .then(() => this.commonService.alertModal("Número de teléfono", 2))
                        .catch(() =>
                            this.commonService.alertModal("Número de teléfono", 3)
                        );
                } else {
                    this.commonService.alertModal("Número de teléfono", 3);
                }
            })
            .catch(() => this.commonService.alertModal("Número de teléfono", 3));
    }

    getUserFirebase(): void {
        this.auth
            .getUserFirebase()
            .then((res) => {
                if (res["emailVerified"] === true) {
                    this.updateUserEmailVerified(this.user.uid).catch(() =>
                        this.redirectToLogin()
                    );
                } else {
                    this.redirectToLogin();
                }
            })
            .catch(() => this.redirectToLogin());
    }


    updateUserEmailVerified(uid: string): Promise<void> {
        const messagePost = { emailVerified: true };
        return this.updateUser(messagePost, uid);
    }

    redirectToLogin(): void {
        this.auth
            .logout()
            .then(() => {
                this.router.navigate(["/pages/login"]).then(() => {
                    Swal.fire(
                        "Estimado usuario",
                        "Por motivos de seguridad, es necesario validar su cuenta para poder continuar con el proceso de compra, " +
                        "se le ha enviado un correo electronico para validar su cuenta, favor de verificar e inciar sesión nuevamente",
                        "info"
                    );
                    this.auth
                        .sendEmailVerification()
                        .then(() => console.log("Email verification sent"))
                        .catch((err) =>
                            console.error("Error sending email verification", err)
                        );
                });
            })
            .catch((err) => console.error("Error logging out", err));
    }

    updateUser(message: any, uid: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.subscriptions.add(
                this.service.updateUser(message, uid).subscribe(
                    (response) => resolve(response),
                    (error) => reject(error)
                )
            );
        });
    }

    getDefaultCountry(): void {
        this.subscriptions.add(
            this.http.get<any>("https://ipapi.co/json/").subscribe((response) => {
                const userCountryCode =
                    response.country_calling_code?.replace("+", "") || "503";
                this.selectedCountry = userCountryCode;
                this.phone = this.countryPrefix[userCountryCode] || "";
                this.code = userCountryCode;
            })
        );
    }

    getCountries(): void {
        const countryCodes = ["US", "SV"];
        this.countries = [];

        countryCodes.forEach((code) => {
            this.subscriptions.add(
                this.http
                    .get<any>(
                        `https://restcountries.com/v3.1/alpha/${code}?fields=name,cca2,flags,idd`
                    )
                    .subscribe(
                        (country) => {
                            this.countries.push(country);
                            if (country.cca2 === "US") {
                                this.countryPrefix[country.cca2] = country.idd.root;
                            } else {
                                this.countryPrefix[country.cca2] =
                                    country.idd.root +
                                    (country.idd.suffixes ? country.idd.suffixes[0] : "");
                            }
                        },
                        (error) => console.log(error)
                         )
            );
        });
    }

    onCountryChange(): void {
        this.code = this.countryPrefix[this.selectedCountry] || "";
    }

    getPhonePrefix(country: any): string {
        if (country.cca2 === "US") {
            return country.idd.root;
        }
        return (
            country.idd.root + (country.idd.suffixes ? country.idd.suffixes[0] : "")
        );
    }

    verifyPaymentWompi(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.wompi
                .EnlacePagoId(data)
                .then((confirm: any) => {
                    if (confirm && confirm.cantidadPagosExitosos) {
                        resolve(true);
                    } else {
                        reject(false);
                    }
                })
                .catch((err) => {
                    console.error("Error verifying Wompi payment", err);
                    reject(false);
                });
        });
    }

    getStockProduct(data: any): Promise<any> {
        return new Promise((resolve) => {
            this.subscriptions.add(
                this.service.getOneProduct(data.product_uid).subscribe((res) => {
                    const new_stock = res.products_stock - data.quantity;
                    resolve({
                        id: "",
                        products_stock: new_stock,
                        old_products_stock: res.products_stock,
                        product_availability: new_stock > 0 ? "Out of stock" : "Stock",
                        product_background_availability:
                            new_stock > 0 ? "success" : "danger",
                    });
                })
            );
        });
    }

    updateStockProduct(data: any, product_uid: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.service.updateProduct(data, product_uid).then(resolve).catch(reject);
        });
    }

    async verifyUid(): Promise<void> {
        // ✅ Si ya existe en memoria, usarlo
        if (this.orderId) {
            //console.log('♻️ OrderId ya existe en memoria:', this.orderId);
            return; // ⚠️ No regenerar
        }

        // ✅ Verificar en localStorage
        const uid = localStorage.getItem("orderId");

        if (!uid) {
            // ✅ Generar nuevo solo si NO existe
            const chars = "QWERTYUIOPASDFGHJKLZXCVBNM1234567890";
            let code = "";

            for (let i = 0; i < 9; i++) {
                code += chars.charAt(Math.floor(Math.random() * chars.length));
            }

            this.orderId = code;
            localStorage.setItem("orderId", this.orderId);
            //console.log('🆕 Nuevo orderId aleatorio generado:', this.orderId);
        } else {
            // ✅ Usar el existente y verificar orden previa
            this.orderId = uid;
            //console.log('📋 OrderId de localStorage:', this.orderId);
            await this.verifyOrder(uid);
        }
    }


    verifyOrder(uid: string): Promise<void> {
        return new Promise((resolve) => {
            this.subscriptions.add(
                this.service.getOrderByUid(uid).subscribe((res) => {
                    if (res.success !== true) {
                        this.createAndResetOrderId();
                        return resolve();
                    }

                    const order = res;

                    if (
                        order.orders_status_uid === "Payment Request" &&
                        order.waytopay === "Wompi" &&
                        order.data_wompi
                    ) {
                        const data = {
                            id: order.data_wompi.idLink,
                            token: order.data_wompi.access_token,
                        };

                        this.verifyPaymentWompi(data)
                            .then(() => {
                                const messagePost = {
                                    orders_status_uid: "New",
                                    badgeColor: "primary",
                                    wompy_transaction: true,
                                };

                                this.service
                                    .updateOrder(messagePost, order.id)
                                    .then(async () => {
                                        await this.updateProductsStock(order);
                                        this.createAndResetOrderId();
                                        resolve();
                                    });
                            })
                            .catch(() => {
                                this.createAndResetOrderId();
                                resolve();
                            });
                    } else {
                        this.createAndResetOrderId();
                        resolve();
                    }
                })
            );
        });
    }

    private async updateProductsStock(order: any): Promise<void> {
        for (const element of order.items) {
            try {
                const dataProduct = {
                    product_uid: element.uid,
                    quantity: element.quantity,
                };

                const dataUpdate = await this.getStockProduct(dataProduct);
                const clonedObject = { ...dataUpdate };
                const messagePost = {
                    products_stock: dataUpdate["products_stock"],
                };

                const dataLog = {
                    reason: `Update product - Wompi ${this.orderId}`,
                    user_uid: this.user.uid,
                    name_user: `${this.user.firstName} ${this.user.lastName}`,
                    date: Date.now(),
                    from: "Tienda Online",
                    product_uid: element.id,
                    data_send: element,
                    quantity_before: clonedObject.products_stock,
                    quantity_after: element.products_stock,
                    price_before: clonedObject.old_products_stock,
                    price_after: clonedObject.price_tax_product,
                    discount_before: clonedObject.discount,
                    discount_after: clonedObject.discount,
                };

                const log = {
                    info: dataLog,
                    product_uid: element.id,
                };

                await this.productService.saveLog(log);
                await this.updateStockProduct(messagePost, element.uid);
            } catch (error) {
                console.error("Error updating product stock:", error);
            }
        }
    }

    private createAndResetOrderId(): void {
        const chars = "QWERTYUIOPASDFGHJKLZXCVBNM1234567890";
        let code = "";

        for (let i = 0; i < 9; i++) {
            code += chars.charAt(Math.floor(Math.random() * chars.length));
        }

        this.orderId = code;
        localStorage.setItem("orderId", this.orderId);
        localStorage.removeItem("order_uid");
    }


    ToFixed(valor: number): string {
        return Number(valor).toFixed(2);
    }

    verificationPhone(): void {
        this.subscriptions.add(
            this.service.sendGET_SettingsApp("General").subscribe((res) => {
                if (res.active_verification_phone !== undefined) {
                    this.active_verification_phone = res.active_verification_phone;
                }
            })
        );
    }

    // Helper functions moved to component methods
    getTax(): number {
        const tax_percent = this.unique_tax ? this.tax : this.tax_business;
        let tax = 0;

        if (this.view_tax) {
            this.getTotal.subscribe((subtotal) => {
                tax = this.include_tax
                    ? subtotal - subtotal / (1 + tax_percent)
                    : subtotal * tax_percent;
            });
        }

        return tax;
    }

    getDelivery(): number {
        return this.var_delivery_active && this.delivery_method ? this.delivery : 0;
    }

    getSubtotal(): number {
        const tax_percent = this.unique_tax ? this.tax : this.tax_business;
        let subtotal = 0;

        this.getTotal.subscribe((total) => {
            subtotal = total;
        });

        return subtotal;
    }

    serviceFee(): number {
        return this.include_service_fee
            ? 0
            : this.getSubtotal() * this.service_fee_percent;
    }

    usedCredits(): number {
        return this.used_credits ? this.total_wallet : 0;
    }

    getNewTotal(): number {
        let newTotal = 0;
        const subtotal = this.getSubtotal();
        const serviceFee = this.serviceFee();
        const tax = this.getTax();
        const delivery = this.getDelivery();
        const credits = this.usedCredits();

        if (this.include_service_fee) {
            if (this.include_tax) {
                newTotal = this.view_tax ? subtotal + tax : subtotal;
            } else {
                newTotal = subtotal + tax;
            }
        } else {
            if (this.include_tax) {
                newTotal = this.view_tax
                    ? subtotal + tax + serviceFee
                    : subtotal + serviceFee;
            } else {
                newTotal = subtotal + serviceFee + tax;
            }
        }

        if (this.used_credits) {
            if (credits > newTotal) {
                this.total_credits_used = newTotal;
                newTotal = 0;
            } else {
                newTotal -= credits;
                this.total_credits_used = credits;
            }
        }

        if (this.var_delivery_active && this.delivery_method) {
            newTotal += this.delivery;
        }

        return newTotal;
    }


   async processPowerTranzPayment(): Promise<void> {
    try {
        this.showProcessingPaymentAlert();

        // ✅ Asegurar que orderId existe ANTES de todo
        await this.verifyUid();

        if (!this.orderId) {
            throw new Error('Error: orderId no disponible');
        }

        //console.log('🔑 OrderID confirmado:', this.orderId);

        // Generar identificadores ÚNICOS
        this.TransactionIdentifier = this.generateUUID();
        this.orderIdentifier = this.orderId;

        //console.log('📋 TransactionIdentifier:', this.TransactionIdentifier);
        //console.log('📋 OrderIdentifier:', this.orderIdentifier);

        const cleanPhoneNumber = this.user.phone.internationalNumber.replace(/\D/g, '');

        // Convertir a centavos
        this.totalAmount = Number(this.getNewTotal().toFixed(2));
        const taxAmountCents = Math.trunc(Number.parseFloat(this.getTax().toString()) * 100);

        let powerTranzData: any;

        // ✅ CASO 1: PAGO CON NUEVA TARJETA
        if (this.shownewCardForm && this.newCardForm.valid) {
            //console.log('💳 Pagando con NUEVA tarjeta');
            const formValue = this.newCardForm.value;
            const cleanCardNumber = formValue.cardNumber.replace(/\s/g, '');
            const cardExpiration = formValue.expYear + formValue.expMonth.padStart(2, '0');

            powerTranzData = {
                "render": true,
                "TransactionIdentifier": this.TransactionIdentifier,
                "CurrencyCode": "840",
                "OrderIdentifier": this.orderId,
                "Source": {
                    "CardPan": cleanCardNumber,
                    "CardCvv": formValue.cvv,
                    "CardExpiration": cardExpiration,
                    "CardholderName": formValue.cardHolderName.trim()
                },
                "BillingAddress": {
                    "PhoneNumber": cleanPhoneNumber,
                    "EmailAddress": this.user.email,
                },
                "ThreeDSecure": true,
                "TotalAmount": this.totalAmount,
                "TaxAmount": taxAmountCents,
                "ExtendedData": {
                    "ThreeDSecure": {
                        "ChallengeWindowSize": 5,
                        "ChallengeIndicator": "01"
                    },
                    "MerchantResponseUrl": `https://us-central1-ianos-app-sv-pollo-real-pro.cloudfunctions.net/powertranz/v1/payment/e1baa4e88b1-e5b0cb5cfa7f4-4ebf-a4bfb3a2/${this.orderId}`
                },
                "AddressMatch": true
            };
        }
        // ✅ CASO 2: PAGO CON TARJETA GUARDADA
        else if (this.selectedCard && !this.shownewCardForm) {
            //console.log('💳 Pagando con tarjeta GUARDADA:', this.selectedCard.last_digits);
            powerTranzData = {
                "render": true,
                "TransactionIdentifier": this.TransactionIdentifier,
                "CurrencyCode": "840",
                "OrderIdentifier": this.orderId,
                "Source": {
                    "Token": this.selectedCard.pan_token,
                    "CardholderName": this.selectedCard.card_holder_name
                },
                "ThreeDSecure": true,
                "TotalAmount": this.totalAmount,
                "TaxAmount": taxAmountCents,
                "ExtendedData": {
                    "ThreeDSecure": {
                        "ChallengeWindowSize": 5,
                        "ChallengeIndicator": "01"
                    },
                    "MerchantResponseUrl": `https://us-central1-ianos-app-sv-pollo-real-pro.cloudfunctions.net/powertranz/v1/payment/e1baa4e88b1-e5b0cb5cfa7f4-4ebf-a4bfb3a2/${this.orderId}`
                },
                "AddressMatch": false
            };
        } else {
            const errorMsg = !this.shownewCardForm && !this.selectedCard
                ? 'Debes seleccionar una tarjeta guardada o agregar una nueva'
                : 'El formulario de nueva tarjeta está incompleto';
            throw new Error(errorMsg);
        }

        // ✅ PREPARAR DIRECCIÓN DE USUARIO
        const templateContent = document.getElementById("table-invoice")?.innerHTML || "";
        localStorage.setItem("templateContent", templateContent);
        const userDirection = this.getUserDirection();

        // ✅ PREPARAR ITEMS DE LA ORDEN
        const items = this.products.map(element => ({
            image: element.images[0].src,
            name: element.title,
            quantity: element.quantity,
            price: element.price_tax_product_discount,
            discount: element.product_promote ? element.discount : 0,
            sum: +(element.price_tax_product_discount * element.quantity).toFixed(2),
            subtotal: +(element.price_tax_product_discount * element.quantity).toFixed(2),
            uid: element.id,
            description: element.description,
            category_uid: element.category_uid,
        }));

        // ✅ PREPARAR UBICACIONES
        let place_delivery_user: any = {};
        let user_ubication: any = {};
        let commerce_ubication: any = {};

        if (this.method_shipping === "Delivery") {
            if (this.user.direction && this.user.direction.length > 0) {
                const defaultDirection = this.user.direction.find((d: any) => d.is_default === true);
                if (defaultDirection) {
                    place_delivery_user = defaultDirection;
                    user_ubication = {
                        lat: defaultDirection.lat_long?._lat,
                        long: defaultDirection.lat_long?._long
                    };
                }
            }

            const commerceUbi = localStorage.getItem('commerce_ubication');
            if (commerceUbi && commerceUbi !== '' && commerceUbi !== 'undefined') {
                commerce_ubication = JSON.parse(commerceUbi);
            }
        }

        // ✅ PREPARAR DATOS DE FECHA
        const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        const WEEKS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        const now = new Date();
        const formatdate = `${WEEKS[now.getDay()]}, ${now.getDate()} of ${MONTHS[now.getMonth()]} of ${now.getFullYear()} ${now.getHours()}:${now.getMinutes()}`;

        // ✅ ORDEN COMPLETA CON TODOS LOS CAMPOS
        const orderForPowerTranz = {
            // Identificadores
            uid: this.orderId,
            orderId: this.orderId,
            transaction_identifier: this.TransactionIdentifier,
            
            // Montos
            amount: Number(this.getSubtotal().toFixed(2)),
            subtotal: Number(this.getSubtotal().toFixed(2)),
            tax: Number(this.getTax().toFixed(2)),
            subtotalForRide: Number(this.getDelivery().toFixed(2)),
            serviceFee: Number(this.serviceFee().toFixed(2)),
            service_fee: Number(this.serviceFee().toFixed(2)),
            used_credits: Number(this.total_credits_used.toFixed(2)),
            total: Number(this.getNewTotal().toFixed(2)),
            totalAmount: Number(this.getNewTotal().toFixed(2)),
            totalInCents: Math.trunc(this.getNewTotal() * 100),
            discount: 0,
            discount_percent: 0,
            tip_amount: 0,
            tip_porcent: '0',
            
            // Items/Productos
            items: items,
            product: this.products,
            
            // Usuario
            user_uid: this.user.uid,
            user_email: this.user.email,
            user_name: `${this.user.firstName} ${this.user.lastName}`,
            who_receives: `${this.user.firstName} ${this.user.lastName}`,
            
            // Detalles del checkout
            details: this.checkoutForm.value,
            
            // Envío/Delivery
            is_delivery: this.method_shipping === "Delivery",
            method_shipping: this.method_shipping,
            direction: userDirection,
            place_delivery_user: place_delivery_user.name_place || '',
            user_ubication: user_ubication,
            commerce_ubication: commerce_ubication,
            
            // Comercio
            commerce_uid: this.comercioId || localStorage.getItem('commerce_uid') || '',
            commerce_name: localStorage.getItem('sucursal') || '',
            commerce_direction: localStorage.getItem('commerce_direction') || '',
            sucursal: localStorage.getItem('sucursal') || '',
            commerce_image: localStorage.getItem('commerce_image') || '',
            
            // Método de pago
            waytopay: 'Tarjeta débito / crédito',
            payment: 'Tarjeta débito / crédito',
            is_card: true,
            is_bitcoin: false,
            
            // Facturación
            invoicing: localStorage.getItem('invoicing') || '',
            need_invoice: false,
            shipping: localStorage.getItem('shipping') || '',
            
            // Estado de la orden
            order_active: true,
            orders_status_uid: 'New',
            badgeColor: 'primary',
            status_user: true,
            order_on_hold: false,
            
            // Fechas
            created_at_formatted: formatdate,
            doc_created_date: now.toISOString().split('T')[0], // YYYY-MM-DD
            order_createday: new Date(),
            order_lastupdateday: new Date(),
            
            // Notificaciones
            is_notified_client: false,
            is_notified_commerce: false,
            
            // Otros
            isWeb: true,
            isGift: false,
            customer_payment_uid: '',
            manager_uid: '',
            manager_user_uid: '',
            deparment: '',
            municipality: '',
            transactions: [],
           
        };

        // ✅ Estructura completa para enviar a PowerTranz
        const powerTranzPayload = {
            sale: powerTranzData,
            order: orderForPowerTranz
        };

        //console.log('📤 Enviando a PowerTranz v1/sale:', JSON.stringify(powerTranzPayload, null, 2));

        // ✅ ENVIAR A POWERTRANZ v1/sale
        const response = await this.service.sendPOST(
            'https://us-central1-ianos-app-sv-pollo-real-pro.cloudfunctions.net/powertranz/v1/sale',
            powerTranzPayload,
            {
                headers: { 'Content-Type': 'application/json' },
                responseType: 'text',
                observe: 'response'
            }
        );

        Swal.close();

        if (response && response.body) {
            if (response.body.includes('<html>') || response.body.includes('<form>')) {
                //console.log('🔐 Requiere 3D Secure');
                await this.openPowerTranzInAppBrowser(response.body);
            }
            else if (response.success) {
                //console.log('✅ Pago exitoso PowerTranz (sin 3DS)');
                // ✅ El backend ya creó la orden, solo limpiar y redirigir
                await this.handleSuccessfulPowerTranzPayment();
            }
        }

    } catch (error) {
        this.handlePaymentError(error);
    }
}

    private async handleSuccessfulPaymentFromFirebase(transactionData: any) {
    if (transactionData.Approved === true && transactionData.IsoResponseCode === '00') {
        //console.log('✅ Pago exitoso PowerTranz desde Firebase:', transactionData);
        
        Swal.close();
        
        // ✅ Tokenizar tarjeta si fue seleccionada la opción
        if (this.saveCard) {
            //console.log('💳 Guardando tarjeta tokenizada...');
            this.service.sendGET(
                `${environment.urlBase}/powertranz/v2/user/token/${environment.apikey}/${this.TransactionIdentifier}/${this.orderIdentifier}/${this.user.uid}`
            ).subscribe(
                () => //console.log('✅ Tarjeta guardada'),
                (error) => console.error('❌ Error guardando tarjeta:', error)
            );
        }
        
        // ✅ CRÍTICO: Solo limpiar carrito y redirigir
        // NO llamar a PayOtherPost() porque eso crearía orden duplicada
        this.productService.clearCart();
        localStorage.removeItem("cartItems");
        localStorage.removeItem("orderId");
        
        // El backend ya guardó order_uid, solo obtenerlo y redirigir
        const orderUid = localStorage.getItem("order_uid");
        
        if (!orderUid) {
            // Si no está en localStorage, usar el orderId
            console.warn('⚠️ order_uid no encontrado, usando orderId:', this.orderId);
            
            Swal.fire({
                icon: "success",
                title: "Pago Exitoso",
                text: "Tu orden ha sido procesada correctamente",
                timer: 2000,
                showConfirmButton: false
            }).then(() => {
                window.location.href = `/shop/checkout/success/${this.orderId}`;
            });
        } else {
            //console.log('✅ Order UID obtenido:', orderUid);
            
            Swal.fire({
                icon: "success",
                title: "Pago Exitoso",
                text: "Tu orden ha sido procesada correctamente",
                timer: 2000,
                showConfirmButton: false
            }).then(() => {
                window.location.href = `/shop/checkout/success/${orderUid}`;
            });
        }
        
    } else {
        // Pago rechazado
        Swal.fire({
            icon: 'error',
            title: 'Pago Rechazado',
            text: transactionData.ResponseMessage || 'La transacción no fue aprobada'
        });
    }
}


    async handleSuccessfulPowerTranzPayment(): Promise<void> {
        try {
            // Limpiar carrito
            this.productService.clearCart();
            localStorage.removeItem("cartItems");

            // Obtener order_uid del localStorage (el backend lo guardó)
            const orderUid = localStorage.getItem("order_uid");

            if (!orderUid) {
                throw new Error('No se pudo obtener order_uid después del pago');
            }

            // Limpiar orderId temporal
            localStorage.removeItem("orderId");

            // Redirigir a página de éxito
            Swal.fire({
                icon: "success",
                title: "Pago Exitoso",
                text: "Tu orden ha sido procesada correctamente",
                timer: 2000,
                showConfirmButton: false
            }).then(() => {
                window.location.href = `/shop/checkout/success/${orderUid}`;
            });

        } catch (error) {
            console.error('Error en handleSuccessfulPowerTranzPayment:', error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Hubo un problema procesando la orden",
            });
        }
    }


  async PayOtherPost(): Promise<void> {
    try {
        const paymentMethod = localStorage.getItem('payment');

        // ✅ SI ES POWERTRANZ, el backend ya creó la orden - SOLO REDIRIGIR
        if (paymentMethod === 'PowerTranz') {
            //console.log('⚠️ PowerTranz detectado en PayOtherPost - esto NO debería llamarse');
            //console.log('El backend ya creó la orden, solo redirigiendo...');
            
            // Limpiar y redirigir
            this.productService.clearCart();
            localStorage.removeItem("cartItems");
            localStorage.removeItem("orderId");
            
            const orderUid = localStorage.getItem("order_uid") || this.orderId;
            window.location.href = `/shop/checkout/success/${orderUid}`;
            return;
        }

        // ✅ PARA OTROS MÉTODOS DE PAGO (Cash, Transfer, etc.)
        //console.log('📝 Procesando orden con método de pago:', paymentMethod);

        const templateContent = document.getElementById("table-invoice")?.innerHTML || "";
        localStorage.setItem("templateContent", templateContent);
        const userDirection = this.getUserDirection();

        const dataCreateOrder = {
            product: this.products,
            details: this.checkoutForm.value,
            orderId: this.orderId,
            amount: this.getNewTotal(),
            tax: this.getTax(),
            is_delivery: this.method_shipping === "Delivery",
            method_shipping: this.method_shipping,
            subtotalForRide: this.delivery,
            subtotal: this.getSubtotal(),
            serviceFee: this.serviceFee(),
            used_credits: this.total_credits_used,
            direction: userDirection
        };

        // ✅ Crear orden SOLO para métodos que NO sean PowerTranz
        this.orderService.createOrder(dataCreateOrder);
        this.productService.clearCart();

        try {
            await this.orderService.processOrder(this.user, 666);
        } catch (error) {
            console.error('Error en processOrder:', error);

            const orderUid = localStorage.getItem("order_uid");
            if (orderUid) {
                Swal.fire({
                    icon: "success",
                    title: "Pedido Creado",
                    text: "Orden procesada exitosamente",
                }).then(() => {
                    localStorage.removeItem("cartItems");
                    localStorage.removeItem("orderId");
                    window.location.href = `/shop/checkout/success/${orderUid}`;
                });
            } else {
                throw new Error('No se pudo obtener order_uid');
            }
        }

    } catch (error) {
        console.error('❌ Error en PayOtherPost:', error);
        Swal.fire({
            icon: "error",
            title: "Error",
            text: "Hubo un problema procesando la orden",
        });
    }
}


    private generateUUID(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0;
            const v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    async getCardFromFirebase(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.subscriptions.add(
                this.firestoreService.getOne("Cards", this.user.uid).subscribe(

                    (cardsData: any) => {
                        ////console.log(cardsData);
                        if (cardsData && cardsData.cards && cardsData.cards.length > 0) {
                            // Find selected card or first active card
                            const selectedCard = cardsData.cards.find((card: any) =>
                                card.is_selected && card.status && card.pan_token
                            );
                            resolve(selectedCard || null);
                        } else {
                            resolve(null);
                        }
                    },
                    (error) => reject(error)
                )
            );
        });

    }


    async openPowerTranzInAppBrowser(htmlContent: string): Promise<void> {
        try {
            ////console.log('Abriendo PowerTranz en Angular:', htmlContent);

            // Crear un blob URL con el contenido HTML
            const blob = new Blob([htmlContent], { type: 'text/html' });
            const url = URL.createObjectURL(blob);

            // Abrir ventana popup
            this.paymentWindow = window.open(
                url,
                'powertranz_payment',
                'width=800,height=600,scrollbars=yes,resizable=yes,menubar=no,toolbar=no,location=no,status=no'
            );

            if (!this.paymentWindow) {
                throw new Error('No se pudo abrir la ventana de pago. Verifique que no esté bloqueando popups.');
            }

            // Marcar que el pago está en proceso
            this.isPaymentProcessing = true;

            // Mostrar loader usando SweetAlert (como ya usas en el proyecto)
            this.showPaymentProcessingAlert();

            // Iniciar monitoreo del cierre de ventana
            this.startPaymentWindowMonitoring();

            // Timeout de seguridad (5 minutos)
            this.paymentTimeout = setTimeout(() => {
                this.handlePaymentTimeout();
            }, 300000);

        } catch (error) {
            console.error('Error abriendo ventana PowerTranz:', error);
            Swal.fire('Error', 'No se pudo abrir la ventana de pago: ' + error.message, 'error');
        }
    }

    private showPaymentProcessingAlert(): void {
        Swal.fire({
            icon: "info",
            title: "Procesando pago seguro...",
            text: "Por favor, complete el pago en la ventana emergente",
            showConfirmButton: false,
            backdrop: "static",
            allowOutsideClick: false,
        });
    }

    private startPaymentWindowMonitoring() {
        // Verificar cada 1 segundo si la ventana se cerró
        this.paymentCheckInterval = setInterval(() => {
            if (this.paymentWindow && this.paymentWindow.closed) {
                ////console.log('Ventana de pago cerrada, verificando resultado en Firebase...');
                this.clearPaymentMonitoring();
                this.checkPaymentResultInFirebase();
            }
        }, 1000);
    }

    private clearPaymentMonitoring() {
        if (this.paymentCheckInterval) {
            clearInterval(this.paymentCheckInterval);
            this.paymentCheckInterval = null;
        }

        if (this.paymentTimeout) {
            clearTimeout(this.paymentTimeout);
            this.paymentTimeout = null;
        }
    }



    private async checkPaymentResultInFirebase() {
        try {
            Swal.fire({
                icon: "info",
                title: "Verificando resultado del pago...",
                text: "Esto puede tomar unos segundos",
                showConfirmButton: false,
                backdrop: "static",
                allowOutsideClick: false,
            });

            const result = await this.searchPaymentInFirebase();

            if (result.success) {
                await this.handleSuccessfulPaymentFromFirebase(result.data);
            } else if (result.timeout) {
                await this.handlePaymentVerificationTimeout();
            } else {
                await this.handlePaymentNotFound();
            }

        } catch (error) {
            console.error('Error verificando pago en Firebase:', error);
            await this.handlePaymentVerificationError(error);
        } finally {
            this.isPaymentProcessing = false;
            Swal.close();
        }
    }

 
    private async searchPaymentInFirebase(): Promise<{ success: boolean, data?: any, timeout?: boolean }> {
        return new Promise((resolve) => {
            let attempts = 0;
            const maxAttempts = 30; // 30 intentos = 30 segundos

            const checkInterval = setInterval(async () => {
                attempts++;
                ////console.log(`Intento ${attempts} de verificación en Firebase...`);

                try {
                    // Usar tu servicio de Firestore existente en lugar de imports de Firebase
                    this.subscriptions.add(
                        this.firestoreService.getWhere('TransactionsCompleted', 'TransactionIdentifier', this.TransactionIdentifier)
                            .subscribe(
                                (transactions: any[]) => {
                                    if (transactions && transactions.length > 0) {
                                        // Encontrado!
                                        ////console.log('Transacción encontrada en Firebase:', transactions[0]);

                                        clearInterval(checkInterval);
                                        resolve({ success: true, data: transactions[0] });
                                        return;
                                    }

                                    // Si llegamos al máximo de intentos
                                    if (attempts >= maxAttempts) {
                                        clearInterval(checkInterval);
                                        resolve({ success: false, timeout: true });
                                        return;
                                    }
                                },
                                (error) => {
                                    console.error(`Error en intento ${attempts}:`, error);

                                    if (attempts >= maxAttempts) {
                                        clearInterval(checkInterval);
                                        resolve({ success: false, timeout: true });
                                        return;
                                    }
                                }
                            )
                    );

                } catch (error) {
                    console.error(`Error en intento ${attempts}:`, error);

                    if (attempts >= maxAttempts) {
                        clearInterval(checkInterval);
                        resolve({ success: false, timeout: true });
                        return;
                    }
                }
            }, 1000); // Verificar cada segundo
        });
    }
    private async handlePaymentNotFound() {
        Swal.fire({
            icon: 'warning',
            title: 'Verificación de Pago',
            text: 'No se pudo confirmar el estado de la transacción. Si el dinero fue debitado de su tarjeta, el pago será procesado automáticamente. Para cualquier consulta, contacte con soporte.'
        });
    }

    private async handlePaymentVerificationTimeout() {
        Swal.fire({
            icon: 'warning',
            title: 'Tiempo de Espera Agotado',
            text: 'La verificación del pago está tomando más tiempo del esperado. Su transacción será procesada automáticamente si fue exitosa. Puede verificar el estado en su cuenta o contactar con soporte.'
        });
    }

    private async handlePaymentVerificationError(error: any) {
        Swal.fire({
            icon: 'error',
            title: 'Error de Verificación',
            text: 'Ocurrió un error al verificar el estado del pago. Si la transacción fue exitosa, será procesada automáticamente. Contacte con soporte si tiene dudas.'
        });
    }

    private handlePaymentTimeout() {
        ////console.log('Timeout del pago alcanzado');

        if (this.paymentWindow && !this.paymentWindow.closed) {
            this.paymentWindow.close();
        }

        this.clearPaymentMonitoring();
        this.isPaymentProcessing = false;

        Swal.close();

        Swal.fire({
            icon: 'error',
            title: 'Tiempo Agotado',
            text: 'El proceso de pago ha excedido el tiempo límite. Por favor, intente nuevamente.'
        });
    }




    paymentMethod(event: string): void {
        ////console.log('Selected payment method:', event);
        const select = this.metodoPago.find((item) => item.name === event);

        if (select) {
            this.isWompi = select.isWompi || false;
            this.isCash = select.isCash || false;
            this.isStripe = select.isStripe || false;
            this.isPowerTranz = select.isPowerTranz || false;

            this.txtMessage = select.txtMessage || '';
            this.mainStatusOrder = select.mainStatusOrder || '';
            this.mainBadgeColor = select.mainBadgeColor || '';
            this.finalBadgeColor = select.finalBadgeColor || '';
            this.finalStatusOrder = select.finalStatusOrder || '';
            this.txtSuccess = select.txtSuccess || '';

            const txtPayment = this.isWompi ? "Wompi" : event;
            localStorage.setItem("mainBadgeColor", this.mainBadgeColor);
            localStorage.setItem("mainStatusOrder", this.mainStatusOrder);
            localStorage.setItem("finalStatusOrder", this.finalStatusOrder);
            localStorage.setItem("finalBadgeColor", this.finalBadgeColor);
            localStorage.setItem("txtSuccess", this.txtSuccess);
            localStorage.setItem("payment", txtPayment);

            if (this.isPowerTranz) {
                //console.log('Initializing PowerTranz mode...');

                // ✅ RESETEAR el estado del formulario de nueva tarjeta
                this.showNewCardForm = false;
                this.shownewCardForm = false;
                this.newCardForm.reset();

                // ✅ Cargar tarjetas guardadas
                this.loadSavedCards();

                // ✅ Asegurarse de que selectedCard esté disponible
                // Si ya existe una tarjeta seleccionada previamente, mantenerla
                // Si no, se seleccionará automáticamente en loadSavedCards()
            }
        }
    }


    private initAddCardForm(): void {
        this.newCardForm = this.fb.group({
            cardHolderName: ['', [Validators.required, Validators.minLength(3)]],
            cardNumber: ['', [Validators.required, Validators.pattern(/^[0-9\s]{13,19}$/)]],
            cvv: ['', [Validators.required, Validators.pattern(/^[0-9]{3,4}$/)]],
            expMonth: ['', [Validators.required]],
            expYear: ['', [Validators.required]]
        });
    }

    async loadSavedCards(): Promise<void> {
        try {
            if (!this.user?.uid) {
                this.savedCards = [];
                return;
            }

            const cardsData = await this.firestoreService.getOneOnce<any>('Cards', this.user.uid);

            if (cardsData?.cards && Array.isArray(cardsData.cards)) {
                this.savedCards = cardsData.cards
                    .filter(card => card.status === true && card.pan_token)
                    .slice(0, 5)
                    .sort((a, b) => {
                        if (a.is_selected && !b.is_selected) return -1;
                        if (!a.is_selected && b.is_selected) return 1;
                        return (b.created?.seconds || 0) - (a.created?.seconds || 0);
                    });

                const defaultCard = this.savedCards.find(c => c.is_selected);
                this.selectedCard = defaultCard || this.savedCards[0] || null;
            } else {
                this.savedCards = [];
                this.selectedCard = null;
            }
        } catch (error) {
            console.error('Error loading cards:', error);
            this.savedCards = [];
        }
    }


    onCardSelected(card: SavedCard): void {
        this.selectedCard = card;
        this.showNewCardForm = false;
        this.shownewCardForm = false; // ✅ Ocultar formulario de nueva tarjeta
        this.updateSelectedCard(card.id);
    }


    private async updateSelectedCard(cardId: string): Promise<void> {
        try {
            const cardsDoc = await this.firestoreService
                .getOne("Cards", this.user.uid)
                .pipe(take(1))
                .toPromise() as CardsDocument | undefined;

            if (cardsDoc?.cards) {
                const updatedCards = cardsDoc.cards.map(card => ({
                    ...card,
                    is_selected: card.id === cardId
                }));

                await this.firestoreService.update("Cards", this.user.uid, {
                    cards: updatedCards,
                    updated_at: new Date()
                });
            }
        } catch (error) {
            console.error('Error updating selected card:', error);
        }
    }



    cancelNewCard(): void {
        this.showNewCardForm = false;
        this.shownewCardForm = false; // ✅ Ocultar formulario
        this.newCardForm.reset();

        // Re-seleccionar la primera tarjeta guardada si existe
        if (this.savedCards.length > 0) {
            this.selectedCard = this.savedCards[0];
        }
    }


    getExpirationYears(): string[] {
        const currentYear = new Date().getFullYear();
        const years: string[] = [];
        for (let i = 0; i < 15; i++) {
            years.push((currentYear + i).toString().slice(-2));
        }
        return years;
    }

    cancelAddCard(): void {
        this.showAddCardForm = false;
        this.shownewCardForm = false; // ✅ También resetear esta variable
        this.addCardForm.reset();
        this.newCardForm.reset(); // ✅ Resetear también el nuevo formulario
        this.isAddingCard = false;

        // ✅ Re-seleccionar la primera tarjeta si existe
        if (this.savedCards.length > 0) {
            this.selectedCard = this.savedCards[0];
        }
    }


    private detectCardBrand(cardNumber: string): string {
        if (cardNumber.startsWith('4')) return 'Visa';
        if (cardNumber.startsWith('5') || cardNumber.startsWith('2')) return 'Mastercard';
        if (cardNumber.startsWith('34') || cardNumber.startsWith('37')) return 'American Express';
        return 'Unknown';
    }

    private generateCardId(): string {
        return Date.now().toString() + Math.random().toString(36).substr(2, 9);
    }

    private generateTransactionId(): string {
        return Date.now().toString() + Math.random().toString(36).substr(2, 9);
    }


    payWithNewCard(): void {
        this.selectedCard = null; // ✅ Deseleccionar tarjeta guardada
        this.showNewCardForm = true;
        this.shownewCardForm = true;
        this.newCardForm.reset();
        //console.log('🆕 Modo: Pagar con nueva tarjeta');
    }
    async deleteCard(cardId: string, event: Event): Promise<void> {
        event.stopPropagation(); // Evitar que se seleccione la tarjeta al eliminar

        const result = await Swal.fire({
            title: '¿Eliminar tarjeta?',
            text: 'Esta acción no se puede deshacer',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
            try {
                const cardsDoc = await this.firestoreService
                    .getOne("Cards", this.user.uid)
                    .pipe(take(1))
                    .toPromise() as CardsDocument | undefined;

                if (cardsDoc?.cards) {
                    // ✅ Marcar como status: false en lugar de eliminar
                    const updatedCards = cardsDoc.cards.map(card =>
                        card.id === cardId
                            ? { ...card, status: false, deleted_at: new Date() }
                            : card
                    );

                    await this.firestoreService.update("Cards", this.user.uid, {
                        cards: updatedCards,
                        updated_at: new Date()
                    });

                    // Si la tarjeta eliminada estaba seleccionada, limpiar selección
                    if (this.selectedCard?.id === cardId) {
                        this.selectedCard = null;
                    }

                    // Recargar tarjetas
                    await this.loadSavedCards();

                    Swal.fire('Eliminada', 'La tarjeta ha sido eliminada', 'success');
                }
            } catch (error) {
                console.error('Error deleting card:', error);
                Swal.fire('Error', 'No se pudo eliminar la tarjeta', 'error');
            }
        }
    }




}